import React from "react";
import { Handle, Position } from "@xyflow/react";
import { MapPin, Sparkles } from "lucide-react";
import { fileUrl } from "../lib/api";

export function MemberNode({ data }) {
  const { name, photo, birth_date, death_date, location, hobbies, onOpen } = data;
  const deceased = !!death_date;
  const years = [birth_date, death_date].filter(Boolean).map((d) => (d || "").slice(0, 4));
  const yearLabel = years.length ? years.join(" – ") : "";

  return (
    <div onClick={onOpen} data-testid={`tree-node-${data.id}`}
      className="w-[168px] rounded-2xl p-3 cursor-pointer transition-transform active:scale-95 card-surface"
      style={{
        border: deceased ? "1px solid color-mix(in srgb, var(--accent) 55%, transparent)" : "1px solid var(--border)",
        boxShadow: deceased ? "0 0 18px color-mix(in srgb, var(--accent) 22%, transparent)" : "0 8px 24px rgba(0,0,0,0.25)",
      }}>
      <Handle type="target" position={Position.Top} style={{ background: "var(--accent)", width: 8, height: 8 }} />
      <div className="flex flex-col items-center text-center">
        <div className="h-16 w-16 rounded-full overflow-hidden mb-2"
          style={{ border: `2px solid ${deceased ? "var(--accent)" : "var(--border)"}` }}>
          {photo ? (
            <img src={fileUrl(photo)} alt={name} className="h-full w-full object-cover" />
          ) : (
            <div className="h-full w-full grid place-items-center" style={{ background: "var(--bg-elevated)" }}>
              <span className="font-serif-display text-2xl gold-text">{(name || "?").charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="font-serif-display text-lg leading-tight" style={{ color: "var(--text-primary)" }}>{name}</div>
        {yearLabel && <div className="text-[10px] mt-0.5" style={{ color: "var(--text-muted)" }}>{yearLabel}</div>}
        {location && (
          <div className="flex items-center gap-1 mt-1 text-[10px]" style={{ color: "var(--text-secondary)" }}>
            <MapPin size={9} /> {location}
          </div>
        )}
        {hobbies && (
          <div className="flex items-center gap-1 mt-1 text-[10px] leading-tight" style={{ color: "var(--text-secondary)" }}>
            <Sparkles size={9} className="gold-text shrink-0" /> <span className="line-clamp-2">{hobbies}</span>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} style={{ background: "var(--accent)", width: 8, height: 8 }} />
    </div>
  );
}
